import React from 'react';
import './_home.scss';
import AppBar from '../../components/mweb/AppBar/AppBar';
import LocationNav from '../../components/mweb/LocationNav/LocationNav';
import SearchBar from '../../components/mweb/SearchBar/SearchBar';
import BannerCarousel from '../../components/mweb/BannerCarousel/BannerCarousel';
import Categories from '../../components/mweb/Categories/Categories';
import Deals from '../../components/mweb/Deals/Deals';
import USP from '../../components/mweb/USP/USP';
import { getHomePageAndBannerDetail } from 'hb-redux-store/feature/home/home.action';
import { connect } from 'react-redux';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import { HOMEPAGE_SECTIONS } from 'hb-redux-store/util/constantServices';
import { showNonServiceableModal } from 'hb-redux-store/feature/modal/modal.action';
import Blogs from '../../components/mweb/Blogs/Blogs';
import InviteAndEarn from '../../components/mweb/InviteAndEarn/InviteAndEarn';
import Footer from '../../components/mweb/Footer/Footer';
import News from '../../components/mweb/News/News';
import CustomTile from '../../components/common/CustomTile/CustomTile';
import ComboProducts from '../../components/mweb/ComboProducts/ComboProducts';
import LazyLoad from 'react-lazyload';
import LazySection from '../../components/common/LazySection/LazySection';
import { AppDownload } from 'components/mweb/AppDownload/AppDownload';
import MembershipBanner from 'components/mweb/MembershipBanner/MembershipBanner';

class Home extends React.Component {
  state = {
    showNonServiceableModal: false,
    sections: null,
  };

  componentDidMount() {
    this.props.getHomePageAndBannerDetail();
  }
  setHomepageUI = () => {
    const rawSections = this.props.homepageSection;
    let bannerCarousel = null,
      news = null;
    const [lazyOffset, lazyHeight] = [10, 150];
    const sections = rawSections
      .map((s, sectionIndex) => {
        // if (!s.sectionData?.items) return false;
        switch (s.type) {
          case HOMEPAGE_SECTIONS.BANNER_CUSTOM_TILES:
            bannerCarousel = (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <BannerCarousel banners={s.sectionData.items} />
              </React.Fragment>
            );
            return;
          case HOMEPAGE_SECTIONS.CATEGORIES:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <LazyLoad once offset={lazyOffset} height={lazyHeight}>
                  <LazySection data={s} sectionComponent={Categories} />
                </LazyLoad>
                <div className="section-divider" />
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.BESTSELLERS:
          case HOMEPAGE_SECTIONS.DEALS_OF_THE_DAY:
          case HOMEPAGE_SECTIONS.RECENTLY_VIEWED:
          case HOMEPAGE_SECTIONS.RECENTLY_PURCHASED:
          case HOMEPAGE_SECTIONS.ATC_AND_CART_ABANDONED:
            // case HOMEPAGE_SECTIONS.PRE_ORDER:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <LazyLoad once offset={lazyOffset} height={lazyHeight}>
                  <LazySection
                    data={s}
                    sectionComponent={Deals}
                    sectionProps={{
                      title:
                        s.type === HOMEPAGE_SECTIONS.BESTSELLERS
                          ? 'Bestsellers'
                          : s.sectionData.title,
                      showSoldOut:
                        s.type !== HOMEPAGE_SECTIONS.DEALS_OF_THE_DAY,
                      minDealsCount: 1,
                      source: 'homepage',
                    }}
                  />
                </LazyLoad>
                <div className="section-divider" />
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.COMBO_PRODUCTS:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <LazyLoad once offset={lazyOffset} height={lazyHeight}>
                  <LazySection
                    data={s}
                    sectionComponent={ComboProducts}
                    sectionProps={{
                      title: s.sectionData?.items?.title || 'Combo Products',
                      showSoldOut:
                        s.type !== HOMEPAGE_SECTIONS.DEALS_OF_THE_DAY,
                      minDealsCount: 1,
                      source: 'homepage',
                    }}
                  />
                </LazyLoad>
                <div className="section-divider" />
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.PRE_ORDER:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <LazyLoad once offset={lazyOffset} height={lazyHeight}>
                  <LazySection
                    data={s}
                    sectionComponent={Deals}
                    sectionProps={{
                      title: s.sectionData?.title,
                      info: s.sectionData?.info,
                      moreInfo: s.sectionData?.moreInfo || 'View All',
                      moreInfoActionUrl:
                        s.sectionData?.moreInfoActionUrl || '/preorder',
                      source: 'homepage',
                    }}
                  />
                </LazyLoad>
                <div className="section-divider" />
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.USP:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <LazyLoad once offset={lazyOffset} height={lazyHeight}>
                  <LazySection
                    data={s}
                    sectionComponent={USP}
                    sectionProps={{ scrollable: true }}
                  />
                </LazyLoad>
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.BLOGS:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <LazyLoad once offset={lazyOffset} height={lazyHeight}>
                  <LazySection data={s} sectionComponent={Blogs} />
                </LazyLoad>
                <div className="section-divider" />
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.NEWS:
            news = (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <News newsData={s.sectionData.items} />
              </React.Fragment>
            );
            return;
          case HOMEPAGE_SECTIONS.REFER_N_EARN:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <InviteAndEarn
                  key="refer-n-earn"
                  redirectTo={
                    this.props.launchInfo?.loggedIn
                      ? '/my/vxl-point'
                      : '/login?redirectUrl=my/vxl-point'
                  }
                  iGet={this.props.launchInfo?.referrerRewardAmount}
                  myFriendsGet={this.props.launchInfo?.refereeRewardAmount}
                />
                <div className="section-divider--white" />
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.CUSTOM_TILE:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <div className="std-margin-all">
                  <CustomTile ct={s.sectionData} source="homepage" />
                </div>
              </React.Fragment>
            );
        }
      })
      .filter(s => !!s);
    const topSections = [];
    if (bannerCarousel) topSections.push(bannerCarousel);
    if (news) topSections.push(news);
    sections.unshift(...topSections);
    return sections;
  };
  render() {
    const {
      loadingHomepage,
      homepageSection,
      launchInfo,
      cartQty,
      notifications,
    } = this.props;
    return (
      <div className="home-component">
        <div className="std-margin-lr">
          <LocationNav launchInfo={launchInfo} notifications={notifications} />
          <SearchBar />
        </div>
        <AppDownload
          containerStyle="home-app-download-container"
          isSticky={true}
        />
        <MembershipBanner
          source="HOMEPAGE"
          containerStyle="membership-banner-wrapper"
        />
        <div className="section-divider--white"></div>
        {loadingHomepage && <Loader />}
        {!loadingHomepage && homepageSection && homepageSection !== 'failed' && (
          <React.Fragment>
            {this.setHomepageUI()}
            <Footer />
          </React.Fragment>
        )}
        <AppBar cartQty={cartQty} launchInfo={launchInfo} />
      </div>
    );
  }
}

const mapStateToProps = rootReducer => ({
  homepageSection: rootReducer.homeReducer.homepageSection,
  loadingHomepage: rootReducer.homeReducer.loading,
  launchInfo: rootReducer.initialReducer.launchInfo,
  cartQty: rootReducer.cartReducer.cartQtyCount,
  notifications: rootReducer.notificationReducer.notifications,
});
const mapDispactchToProps = {
  getHomePageAndBannerDetail,
  showNonServiceableModal,
};

export default connect(mapStateToProps, mapDispactchToProps)(Home);
